// lista faktur
// @ts-nocheck

import React, { useState } from 'react';
import { format } from 'date-fns';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import { ChevronDown, ChevronRight } from 'react-bootstrap-icons';

import { useGetDashboardInvoices, IDashboardInvoiceListItem } from 'api';
import { Link } from 'components/controls';
import { IPaginationResponse } from 'api/types';

import styles from 'theme/pages/Dashboard/Dashboard.module.scss';

// Lokalne przeciążenie interfejsu z dodatkowymi polami
interface ILocalDashboardInvoiceListItem extends IDashboardInvoiceListItem {
  value_net?: number;
  value_net_formatted?: string;
  value_gross?: number;
  value_gross_formatted?: string;
}

type ILocalResponse = IPaginationResponse<ILocalDashboardInvoiceListItem>;

const Invoices = () => {

  // lista ID'ków rozwiniętych faktur
  const [expandedIds, setExpandedIds] = useState<number[]>([]);

  // pobranie listy faktur z limitem
  const { data: dashboardInvoicesData } = useGetDashboardInvoices({ limit: 10, page: 1 }) as {
    data?: ILocalResponse;
  };

  const toggleExpanded = (id: number) =>
    setExpandedIds((prevState) =>
      prevState.includes(id) ? prevState.filter((item) => item !== id) : [...prevState, id]
    );

  return (
    <div
      className={classnames(
        styles.listWrapper,
        styles.invoices,
        'StylePath-Pages-Dashboard-Components-Invoices'
      )}>
      <div className={styles.listHeader}>
        <Trans>Faktury</Trans>
        <Link
          to="/dashboard/payments"
          className={styles.link}>
          <Trans>więcej</Trans> <ChevronRight />
        </Link>
      </div>

      {(dashboardInvoicesData?.items || []).map((invoice) => (
        <div className={styles.invoice} key={invoice.id}>
          <div
            className={classnames(styles.header, {
              [styles.expanded]: expandedIds.includes(invoice.id)
            })}
            onClick={() => toggleExpanded(invoice.id)}>
            {invoice.symbol} <ChevronDown />
          </div>
          {expandedIds.includes(invoice.id) && (
            <div className={styles.content}>
              <div className={styles.box}>
                <div className={styles.label}>
                  <Trans>Data płatności</Trans>
                </div>
                <div className={styles.value}>
                  {invoice.payment_datetime &&
                    format(new Date(invoice.payment_datetime), 'dd-MM-yyyy')}
                </div>
              </div>
              <div className={styles.box}>
                <div className={styles.label}>
                  <Trans>Data utworzenia</Trans>
                </div>
                <div className={styles.value}>
                  {invoice.issued_datetime && format(new Date(invoice.issued_datetime), 'dd-MM-yyyy')}
                </div>
              </div>
              <div className={styles.box}>
                <div className={styles.label}>
                  <Trans>Wartość brutto</Trans>
                </div>
                <div className={styles.value}>
                  {invoice.value_gross_formatted ? `${invoice.value_gross_formatted} ${invoice.currency}` : '-'}
                </div>
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Invoices;

